import { createSlice } from "@reduxjs/toolkit";
import { domain } from "../../services/constants";
import axios from 'axios';

// const axios = require("axios");

const getAuthHeaders = () => {
  const token = localStorage.getItem("access");
  let header = {
    headers: { Authorization: `Bearer ${token}` },
  };
  return header;
};

export const onboardingSlide = createSlice({
  name: "onboarding",
  initialState: {
    response: []
  },
  reducers: {
    saveOnboarding: (state, action) => {
      state.response = [action.payload];
    }
  }
});

export const saveOnboardingAsync = (data) => async (dispatch) => {
  try {
    // console.log(data);
    const header = getAuthHeaders();
    const API_URL = `${domain}/duonut/save_user_detail`;
    const response = await axios.post(API_URL, data, header);
    // console.log(response);
    dispatch(saveOnboarding(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const { saveOnboarding } = onboardingSlide.actions;
export const showonboardingresponse = (state) => state.onboarding.response;
export default onboardingSlide.reducer;
